module.exports = __webpack_public_path__ + "assets/images/01_1bed4298cf0b59cbaa0f8b325dd5bf25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/01.png
// module id = 261
// module chunks = 0